import React from "react";
import "./input-styled.css";

const CheckboxField = (props: any) => {
  const {
    label,
    id,
    name,
    value,
    checked,
    onChange,
    onBlur,
    labelStyle,
    checkboxStyle,
    front,
    disabled,
    divStyle,
  } = props;
  return (
    <div
      className={`checkbox flex items-center justify-start relative gap-[8px] ${divStyle} `}
    >
      {front && label && (
        <label
          htmlFor={id}
          className={`label text-[#1C2A3D] font-medium text-[14px]  ${labelStyle}`}
        >
          {label}
        </label>
      )}

      <input
        name={name}
        id={id}
        disabled={disabled}
        checked={checked}
        type="checkbox"
        className={`css-checkbox focus:ring-0 focus:ring-offset-0 focus:outline-0 cursor-pointer disabled:cursor-not-allowed disabled:opacity-50 ${checkboxStyle}`}
        onChange={onChange}
        onBlur={onBlur}
        value={value}
      />
      {!front && label && (
        <label
          htmlFor={id}
          className={`label text-[#1C2A3D] font-medium text-[14px]   ${labelStyle}`}
        >
          {label}
        </label>
      )}
    </div>
  );
};

export default CheckboxField;
